<a *ngIf="href; else unwrapped" [attr.href]="href" [attr.target]="target">
  <ng-content *ngTemplateOutlet="unwrapped"></ng-content>
</a>
<ng-template #unwrapped>
  <div class="item-content">
    <ng-content></ng-content>
  </div>
</ng-template>
